import React, { useEffect, useState } from 'react'
import styles from '../../sass/cart.module.scss'
import { Link, useNavigate } from 'react-router-dom'
import { BASE_URL, Icons, IMG } from '../../constant'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCart, updateCart } from '../../redux/actions/cartActions'
import { formatIndianNumber } from '../../utils'
import SelectAddressModal from '../../components/selectAddress'
import { toast } from 'react-toastify'



const ShoppingCart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token, userDetails } = useSelector((state) => state.user);
  const { cart, loader, errors } = useSelector((state) => state.cart);

  const cartItemCount = cart?.totalProducts ? cart?.totalProducts : 0;

  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
      if (modalVisible) {
          document.body.classList.add("modal-open");
      } else {
          document.body.classList.remove("modal-open");
      }

      return () => {
          document.body.classList.remove("modal-open");
      };
  }, [modalVisible]);

  useEffect(() => {
    if (userDetails?.id) {
      dispatch(fetchCart(userDetails.id))
    }
  }, [dispatch, userDetails]);

  const handleDeleteProduct = (productId) => {
    // Show confirmation alert before deleting
    const isConfirmed = window.confirm('Are you sure you want to delete this product from the cart?');

    if (isConfirmed) {
        // Filter out the product to delete
        const updatedProducts = cart.products.filter((item) => item.id !== productId);

        // Recalculate the totals
        const updatedCart = {
            ...cart,
            products: updatedProducts,
            total: updatedProducts.reduce((sum, item) => sum + item.quantity * item.mrp, 0),
            discountedTotal: updatedProducts.reduce(
                (sum, item) => sum + item.quantity * (item.mrp - item.offer_price),
                0
            ),
            totalQuantity: updatedProducts.reduce((sum, item) => sum + item.quantity, 0),
            totalProducts: updatedProducts.length,
        };

        // Dispatch the updated cart
        dispatch(updateCart(updatedCart))
            .unwrap()
            .then(() => {
              toast.info('Product removed from cart!');
            })
            .catch((err) => {
              toast.error('Failed to remove product from cart.');
              console.error('Error:', err);
            });
    } else {
        console.log('Delete canceled');
    }
  };

  const handleIncrementQuantity = (productId) => {
    console.log('Incrementing product quantity:', productId);

    const updatedProducts = cart.products.map((item) =>
        item.id === productId
            ? { ...item, quantity: item.quantity + 1 }
            : item
    );

    const updatedCart = {
        ...cart,
        products: updatedProducts,
        total: updatedProducts.reduce((sum, item) => sum + item.quantity * item.mrp, 0),
        discountedTotal: updatedProducts.reduce((sum, item) => sum + item.quantity * (item.mrp - item.offer_price), 0),
        totalQuantity: updatedProducts.reduce((sum, item) => sum + item.quantity, 0),
        totalProducts: updatedProducts.length,
    };

    dispatch(updateCart(updatedCart));
  };

  const handleDecrementQuantity = (productId) => {
      console.log('Decrementing product quantity:', productId);

      const updatedProducts = cart.products.map((item) =>
          item.id === productId && item.quantity > 1
              ? { ...item, quantity: item.quantity - 1 }
              : item
      );

      const updatedCart = {
          ...cart,
          products: updatedProducts,
          total: updatedProducts.reduce((sum, item) => sum + item.quantity * item.mrp, 0),
          discountedTotal: updatedProducts.reduce((sum, item) => sum + item.quantity * (item.mrp - item.offer_price), 0),
          totalQuantity: updatedProducts.reduce((sum, item) => sum + item.quantity, 0),
          totalProducts: updatedProducts.length,
      };

      dispatch(updateCart(updatedCart));
  };


  if (loader) {
    return (
      <div className={styles.loaderContainer}>
        <span className={styles.loaderText}>Loading...</span>
      </div>
    );
  }

  if (errors) {
    return (
      <>
        {/* <div className={styles.errorContainer}>
          <p className={styles.errorText}>Error: {errors?.message || JSON.stringify(errors, null, 2)}</p>
        </div> */}
        <div className={styles.Cart_emptyContainer}>
          <div className={styles.Cart_emptyWrapper}>
            <img alt='cempty' src={IMG.cempty} />
            <div className={styles.Cart_emptyHeadingWrapper}>
              <div className={styles.Cart_emptyHeading_title}>Your cart is empty</div>
              <div className={styles.Cart_emptyHeading_subtitle}>Looks like you have not added anything to your cart.
              Go ahead & explore <Link to='/search' className={styles.Cart_emptyLink}>top brands.</Link> </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  const getDiscountPercentage = (regularPrice, salePrice) => {
    if (regularPrice && salePrice && regularPrice > salePrice) {
      return ((regularPrice - salePrice) / regularPrice) * 100;
    }
    return 0;
  };

  const products = Array.isArray(cart?.products) ? cart?.products : [];
  // const total = cart?.total || 0;

  const deliveryCharges = (cart?.total - cart?.discountedTotal) >= 2500 ? formatIndianNumber(0) : products.length>0  ? formatIndianNumber(150) : formatIndianNumber(0); // 150 Don't miss

  return (
    <>
    <div className={styles.Content_cartContainer}>
      <div className={'BreadCrumb'}>
        <Link to={'/'} className={`BreadCrumbLink_breadCrumb ${styles.BreadCrumbLink_breadCrumb_first}`}>Home</Link>
        <Link to={null} className={'BreadCrumbLink_breadCrumb'}>Cart</Link>
      </div>
      <div className={styles.style_cart_wrapper}>
        <div className={styles.LHS_container}>
          <div className={styles.style_CartHeader}>
            <div className={styles.style_cartCountWrapper}>
              <span className={styles.style_cartCount}>{cartItemCount} {cartItemCount > 1 ? 'Items' : 'Item'} in your Cart</span>
            </div>
          </div>
          {products.length === 0 ? (
            <div className={styles.Cart_emptyWrapper}>
              <img alt='cempty' src={IMG.cempty} />
              <div className={styles.Cart_emptyHeadingWrapper}>
                <div className={styles.Cart_emptyHeading_title}>Your cart is empty</div>
                <div className={styles.Cart_emptyHeading_subtitle}>Looks like you have not added anything to your cart.
                Go ahead & explore <Link to='/search' className={styles.Cart_emptyLink}>top brands.</Link> </div>
              </div>
            </div>
          ) : (
            <div className={styles.ProductBuckets_container}>

              {products.map((product) => {
                const totalMRP = product.mrp * product.quantity;
                const totalOfferPrice = product.offer_price * product.quantity;
                const totalSave = totalMRP - totalOfferPrice;
                const discount = getDiscountPercentage(totalMRP, totalOfferPrice);

                return (
                  <div className={styles.Bucket_container}>
                    <div className={styles.ProductCard_productContainer}>
                      <div className={styles.ProductCard_row}>
                        <div>
                          <img className={styles.ProductCard_productImage} width={74} height={95} src={`${ BASE_URL + product.image}`} />
                        </div>
                        <div className={styles.ProductCard_content}>
                          <div className={styles.ProductCard_heading}>
                            <p className={styles.ProductCard_name}>{product.name}</p>
                            <div className={styles.ProductCard_iconContainer} >
                              <button className={styles.ProductCard_removeItemButton} onClick={() => handleDeleteProduct(product.id)}>
                                <img className={styles.ProductCard_removeItemButton_Icon} src={Icons.remove} alt='remove' />
                              </button>
                            </div>
                          </div>
                          <div className={styles.ProductCard_brandName}>By {product.brand}</div>
                          <div className={styles.ProductCard_productContent}>
                            <div className={styles.ProductCard_innerContentBottom}>
                              <div className={styles.ProductCard_totalAmtWrapper}>
                                <span className={styles.ProductCard_amountText}>₹{totalOfferPrice}*</span>
                                <span className={styles.ProductCard_totalOriginalMrp}>₹{totalMRP}</span>
                                <span className={styles.ProductCard_totalDiscountPrice}> {discount.toFixed(0)}% OFF</span>
                              </div>
                            </div>
                            <div className={styles.quantitySelectorContainer}>
                              <div className={styles.quantitySelector}>
                                <button onClick={() => handleDecrementQuantity(product.id)} disabled={product.quantity === 1} className={styles.quantityButton}>
                                  -
                                </button>
                                <span className={styles.quantityDisplay}>{product.quantity}</span>
                                <button onClick={() => handleIncrementQuantity(product.id)} disabled={product.quantity === 100} className={styles.quantityButton}>
                                  +
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className={styles.ProductCard_edd}>
                            <div className={styles.ProductCard_eddTextWrapper}>
                              <span className={`${styles.ProductCard_eddText}`}>Dispatch time:</span>
                              <span className={`${styles.ProductCard_eddText} ${styles.ProductCard_eddTime}`}>1-2 working days</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            
            </div>
          )}
        </div>
        <div className={styles.RHS_container}>
          <div className={styles.rhsContent_cartTotalWrapper}>
            <div className={styles.totalText}>
              Cart total: <span className={styles.totalText_amt}>₹{ formatIndianNumber(cart?.total - (cart?.discountedTotal - deliveryCharges))}</span>
            </div>
            <div className={styles.proceedBtnWrapper}>
              {cartItemCount > 0 ? (
                <button className={styles.Button_container} onClick={() => setModalVisible(true)}>Select Delivery Address</button>
              ) : (
                <button disabled style={{ opacity: 0.5 }} className={styles.Button_container}>Select Delivery Address</button>
              )}
            </div>
          </div>

          <div className={styles.BillSummarySection_billSummaryWrapper}>
            <div className={styles.BillSummarySection_billSummaryContainer}>
              <div className={styles.BillSummarySection_ellipseTop} style={{ backgroundImage: `url(${IMG.ellipseWhite})` }}></div>
              <div className={styles.BillSummarySection_commBifurcationWrapper}>
                <div className={styles.CommonBifurcation_wrapper}>
                  <div className={styles.CommonBifurcation_billSummaryCard}>
                    <h1 className={styles.CommonBifurcation_billSummaryTitle}>Bill Summary</h1>
                    <div className={styles.BifurcationV2_bifurcationContainer}>
                      <div className={styles.BifurcationV2_bifurcateRow}>
                        <div className={styles.BifurcationV2_billSummaryText}>
                          <span>MRP</span>
                        </div>
                        <div>
                          <span className={styles.BifurcationV2_billSummaryFinalValue}>₹{formatIndianNumber(cart?.total)}</span>
                        </div>
                      </div>
                      <div className={styles.BifurcationV2_bifurcateRow}>
                        <div className={styles.BifurcationV2_billSummaryText}>
                          <span>Discount</span>
                        </div>
                        <div>
                          <span className={`${styles.BifurcationV2_billSummaryFinalValue} ${styles.BifurcationV2_green}`}>-₹{formatIndianNumber(cart?.discountedTotal)}</span>
                        </div>
                      </div>
                    </div>
                    <div className={styles.BifurcationV2_bifurcationContainer}>
                      <div className={styles.BifurcationV2_bifurcateRow}>
                        <div className={styles.BifurcationV2_billSummaryText}>
                          <span>Discounted Value</span>
                        </div>
                        <div>
                          <span className={styles.BifurcationV2_billSummaryFinalValue}>₹{formatIndianNumber(cart?.total - cart?.discountedTotal)}</span>
                        </div>
                      </div>
                      <div className={styles.BifurcationV2_bifurcateRow}>
                        <div className={styles.BifurcationV2_billSummaryText}>
                          <span>Delivery Fee</span>
                        </div>
                        <div>
                          <span className={styles.BifurcationV2_billSummaryFinalValue}>
                          {(cart?.total - cart?.discountedTotal) >= 2500  ? <><span className={styles.BifurcationV2_strike}>₹150.00</span> <span className={styles.BifurcationV2_green}>FREE</span></> : '₹'+deliveryCharges}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className={styles.BifurcationV2_bifurcationContainer}>
                      <div className={styles.BifurcationV2_bifurcateRow}>
                        <div className={`${styles.BifurcationV2_billSummaryText} ${styles.BifurcationV2_amountToBePaid}`}>
                          <span>Amount to be paid</span>
                        </div>
                        <div>
                          <span className={`${styles.BifurcationV2_billSummaryFinalValue} ${styles.BifurcationV2_finalValueBold}`}>₹{formatIndianNumber(cart?.total - (cart?.discountedTotal - deliveryCharges))}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.CommonSavingsBifurcation_savingsBifurcation}>
                    <div className={styles.CommonSavingsBifurcation_savingsContainer}>
                      <div className={styles.CommonSavingsBifurcation_titleContainer}>
                        <img width={24} height={24} alt='icon' src={Icons.savingsCoin} />
                        <div className={styles.CommonSavingsBifurcation_savingsTitle}>
                          <span className={styles.CommonSavingsBifurcation_totalSavingsValue}>₹{formatIndianNumber(cart?.discountedTotal + (deliveryCharges > 0 ? 0 : 150))} </span>
                          Saved in this order
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.BillSummarySection_ellipseBottom} style={{ backgroundImage: `url(${IMG.ellipseWhite})` }}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {modalVisible && ( 
        <SelectAddressModal onClose={() => setModalVisible(false)}/>
    )}
    </>
  )
}

export default ShoppingCart